import './testOrderDetailsScreen.scss';
import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {CommonService} from "../../../shared/services";
import {IAPIResponseType} from "../../../shared/models/api.model";
import StatusCardComponent from "../../../shared/components/status-card/statusCardComponent";
import HeadingComponent from "../../../shared/components/heading/headingComponent";
import TabsWrapperComponent, {
    TabComponent,
    TabContentComponent,
    TabsComponent
} from "../../../shared/components/tabs/tabsComponent";
import DetailsDataKeyValueComponent
    from "../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import TestOrderSummaryDetailsComponent from "./test-order-summary-details/testOrderSummaryDetailsComponent";
import TestOrderAttachmentsDetailsComponent
    from "./test-order-attachments-details/testOrderAttachmentsDetailsComponent";
import TestOrderResultComponent from "./test-order-result-details/testOrderResultComponent";
import TestOrderSampleListComponent from "./test-order-sample-list/testOrderSampleListComponent";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import {ImageConfig} from "../../../constants";
import TooltipComponent from "../../../shared/components/tooltip/tooltipComponent";
import CopyComponent from "../../../shared/components/copyComponent/copyComponent";
import DialogComponent from "../../../shared/components/dialog/dialogComponent";
import {useDispatch} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import LottieFileGenarationComponent
    from "../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import TestOrderLogsComponent from "./test-order-logs/TestOrderLogsComponent";
import commonService from "../../../shared/services/common.service";
import PDFFileForRequisition from "./requisition-pdf-download/RequisitionPdfDownload";
import Visibility from "@mui/icons-material/Visibility";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import SelectDropdownComponent from "../../../shared/components/core/select-dropdown/SelectDropdownComponent";
import Barcode from "react-barcode";
// import Visibility from "@mui/icons-material/Visibility";

const TEST_ORDER_SUMMARY_TAB = 'test_order_information';
const TEST_ORDER_SAMPLES = 'test_order_samples';
const TEST_ORDER_ATTACHMENTS_TAB = 'test_order_attachments';
const TEST_ORDER_RESULT_TAB = 'test_order_result';
const TEST_ORDER_ACTIVITY_LOGS = 'test_order_activity_logs';

interface TestOrderDetailsScreenProps {

}

const TestOrderDetailsScreen = (props: TestOrderDetailsScreenProps) => {
        const [activeTab, setActiveTab] = useState<"test_order_information" | "test_order_attachments" | "test_order_result" | "test_order_activity_logs">(TEST_ORDER_SUMMARY_TAB);
        const navigate = useNavigate();
        const params = useParams<{ testOrderID: string }>();
        const {testOrderID} = params;
        const [testOrderDetails, setTestOrderDetails] = useState<any>(undefined);
        const [isTestOrderDetailsLoading, setIsTestOrderDetailsLoading] = useState<boolean>(false);
        const [isTestOrderDetailsLoaded, setIsTestOrderDetailsLoaded] = useState<boolean>(false);
        const [isTestOrderDetailsLoadingFailed, setIsTestOrderDetailsLoadingFailed] = useState<boolean>(false);
        const [isTestOrderSamplesPrintDialogOpen, setIsTestOrderSamplesPrintDialogOpen] = useState<boolean>(false);
        const [testOrderDetailsMode, setTestOrderDetailsMode] = useState<"view" | "edit">("view");
        const dispatch = useDispatch();

    const [labelSize, setLabelSize] = useState<string>("");
    const printSectionRef = useRef<any>();
    const [currentBarCode, setCurrentBarCode] = useState<string>("")
    const {LabelConfigurations,LabelOptions}=CommonService._staticData;

    const handlePrint = () => {
        try {
            const printContent = printSectionRef?.current?.innerHTML;

            if (!printContent) {
                console.error('No content to print');
                return;
            }

            // Create a new window or iframe for printing
            const printWindow = window.open('', '_blank', 'width=800,height=600');

            if (!printWindow) {
                console.error('Failed to open print window');
                return;
            }
            printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Print</title>
                    <style>
                        /* Add any styles needed for printing */
                        @page {
                            margin: 0; /* Remove default margins */
                        }
                        body {
                            font-family: Arial, sans-serif;
                            margin: 0;
                            padding: 20px;
                        }
                        #print-section {
                              /*border: 1px solid red;*/
                              height: ${LabelConfigurations?.[labelSize]?.height};
                              width: ${LabelConfigurations?.[labelSize]?.width};
                              line-height: ${LabelConfigurations?.[labelSize]?.lineHeight};
                              font-size: ${LabelConfigurations?.[labelSize]?.fontSize};
                        
                              svg {
                                width: 100%;
                                height: auto;
                              }
                        
                              .print-label-value-wrapper{
                                display: flex;
                                align-items: center;
                                  .print-label {
                                    font-weight: bold;
                                  }
                                  .print-value{
                                    flex: 1;
                                    display: inline-block;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                  }
                              }
                        }
                        /* Hide headers and footers */
                        header, footer {
                            display: none;
                        }
                        /* Additional styles if needed */
                    </style>
                </head>
                <body>
                    ${printContent}
                    <script>
                    // Trigger print after content loads
                    window.addEventListener('load', function() {
                        setTimeout(function() {
                            window.print();
                            // Close window after print
                            setTimeout(function() {
                                window.close();
                            }, 100);
                        }, 10);
                    });
                </script>
                </body>
                </html>
            `);
            printWindow.document.close();
            //
            // printWindow.onload = () => {
            //     printWindow.print();
            //     printWindow.close();
            // };
        } catch (error) {
            console.error("An error occurred while printing", error);
        }
    };

        useEffect(() => {
            if (testOrderID) {
                dispatch(setCurrentNavParams("Back", "Test Order", CommonService._routeConfig.TestOrderListRoute()));
                dispatch(setSideMenuView('compact'));
            }
        }, [testOrderID, dispatch, navigate]);

        const getTestOrderDetails = useCallback(() => {
            const payload = {isSampleRequired: true};
            let testOrderDetails: any = {};
            setIsTestOrderDetailsLoading(true);
            setIsTestOrderDetailsLoaded(false);
            setIsTestOrderDetailsLoadingFailed(false);
            CommonService._testOrder.getTestOrderDetails(testOrderID, payload)
                .then((response: IAPIResponseType<any>) => {
                    if (response?.data) {
                        testOrderDetails = response.data;
                    }
                    setTestOrderDetails(testOrderDetails);
                    setIsTestOrderDetailsLoading(false);
                    setIsTestOrderDetailsLoaded(true);
                    setIsTestOrderDetailsLoadingFailed(false);
                })
                .catch((error: any) => {
                    setTestOrderDetails(testOrderDetails);
                    setIsTestOrderDetailsLoading(false);
                    setIsTestOrderDetailsLoaded(false);
                    setIsTestOrderDetailsLoadingFailed(true);
                });
        }, [testOrderID]);


        useEffect(() => {
            if (testOrderID) {
                getTestOrderDetails();
            }
        }, [testOrderID, getTestOrderDetails]);

        const handleActiveTabChange = useCallback((value: any) => {
            if (testOrderDetailsMode === 'edit') {
                CommonService.openConfirmationDialog(
                    {
                        confirmationTitle: 'Please confirm!',
                        confirmationSubTitle: 'Are you sure you want to discard the recent changes?',
                        disableEscKeyClose: false,
                        disableBackdropClose: true,
                        imagePath: `${ImageConfig.ConfirmationImage}`,
                        direction: "up",
                        yes: {
                            text: "Discard",
                            color: "primary"
                        },
                        no: {
                            text: "Cancel",
                            color: "primary"
                        }
                    }).then(() => {
                    setActiveTab(value);
                }).catch(() => {

                })
            } else {
                setActiveTab(value);
            }
        }, [testOrderDetailsMode])

        return (
            <div className="testOrder-details-screen details-screen screen">
                {
                    isTestOrderDetailsLoading && <div className="h-v-center">
                        <LottieFileGenarationComponent
                            loop={true}
                            autoplay={true}
                            animationData={ImageConfig.LoadingLottieFile}/>
                    </div>
                }
                {
                    isTestOrderDetailsLoadingFailed && <>
                        <StatusCardComponent title={"TestOrder details failed to load"}/>
                    </>
                }
                {
                    isTestOrderDetailsLoaded && <>
                        <div className={'details-module-title'}>Test Order Details</div>
                        <div className="basic-details-wrapper">
                            <div className="details-screen-header-status-section">
                                <div className="details-screen-header">
                                    <HeadingComponent
                                        title={`# ${CommonService.capitalizeFirstLetterOfEachWord(testOrderDetails?.code)}`}
                                        statusLabel={testOrderDetails?.status?.replace(' ', '')}
                                    />
                                    <div className="d-flex justify-content-space-between">
                                        {/*{(testOrderDetails?.status === "ordered" || testOrderDetails?.status==="completed") &&*/}
                                        {/*    <div className={'mrg-right-10'}>*/}
                                        {/*        <PDFFileForRequisition showButtonText testOrderDetails={testOrderDetails}/>*/}
                                        {/*    </div>}*/}
                                        <ButtonComponent
                                            variant="contained"
                                            color={'primary'}
                                            handleClick={() => {
                                                setIsTestOrderSamplesPrintDialogOpen(true)
                                            }
                                            }
                                            startIcon={<Visibility/>}
                                        >
                                            Barcode(s)/Requisition Form
                                            {/*Barcode(s)*/}
                                        </ButtonComponent>
                                    </div>
                                </div>
                            </div>

                            <div className="details-screen-sub-header">
                                <DetailsDataKeyValueComponent
                                    title={"Facility:"}
                                    isHorizontal={true}> {CommonService.capitalizeFirstLetterOfEachWord(testOrderDetails?.facilityDetails?.name)} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Location:"}
                                    isHorizontal={true}> {CommonService.capitalizeFirstLetterOfEachWord(testOrderDetails?.locationDetails?.name)} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Created on:"}
                                    isHorizontal={true}>
                                    <>
                                        {commonService.formatDate(testOrderDetails?.createdAt)}
                                        &nbsp;|&nbsp;
                                        {commonService.formatTime(testOrderDetails?.createdAt)}
                                    </>

                                </DetailsDataKeyValueComponent>
                            </div>

                        </div>
                        <div className="clear-fix"/>
                        <div className="details-screen-body">
                            <TabsWrapperComponent>
                                <TabsComponent
                                    value={activeTab}
                                    allowScrollButtonsMobile={false}
                                    onUpdate={(e: any, v: any) => {
                                        handleActiveTabChange(v)
                                    }}
                                    variant={"fullWidth"}
                                >
                                    <TabComponent label="SUMMARY" value={TEST_ORDER_SUMMARY_TAB}/>
                                    <TabComponent label="SAMPLES" value={TEST_ORDER_SAMPLES}/>
                                    <TabComponent label="ATTACHMENTS" value={TEST_ORDER_ATTACHMENTS_TAB}/>
                                    <TabComponent label="RESULT" value={TEST_ORDER_RESULT_TAB}/>
                                    <TabComponent label={"ACTIVITY LOG"} value={TEST_ORDER_ACTIVITY_LOGS}/>
                                </TabsComponent>
                                <TabContentComponent selectedTab={activeTab} value={TEST_ORDER_SUMMARY_TAB}>
                                    <TestOrderSummaryDetailsComponent
                                        testOrderDetails={testOrderDetails}
                                        onModeChange={(mode: any) => {
                                            setTestOrderDetailsMode(mode);
                                        }
                                        }
                                    />
                                </TabContentComponent>
                                <TabContentComponent selectedTab={activeTab} value={TEST_ORDER_SAMPLES}>
                                    <TestOrderSampleListComponent
                                        updateTestOrderDetails={setTestOrderDetails}
                                        testOrderDetails={testOrderDetails}
                                        onModeChange={(mode: any) => {
                                            setTestOrderDetailsMode(mode);
                                        }
                                        }
                                    />
                                </TabContentComponent>
                                <TabContentComponent selectedTab={activeTab} value={TEST_ORDER_ATTACHMENTS_TAB}>
                                    <TestOrderAttachmentsDetailsComponent
                                        testOrderDetails={testOrderDetails}
                                        onModeChange={(mode: any) => {
                                            setTestOrderDetailsMode(mode);
                                        }
                                        }
                                    />
                                </TabContentComponent>
                                <TabContentComponent selectedTab={activeTab} value={TEST_ORDER_RESULT_TAB}>
                                    <TestOrderResultComponent testOrderId={testOrderID}
                                                              onModeChange={(mode: any) => {
                                                                  setTestOrderDetailsMode(mode);
                                                              }
                                                              }
                                    />
                                </TabContentComponent>
                                <TabContentComponent selectedTab={activeTab} value={TEST_ORDER_ACTIVITY_LOGS}>
                                    <TestOrderLogsComponent testOrderId={testOrderID}
                                                            onModeChange={(mode: any) => {
                                                                setTestOrderDetailsMode(mode);
                                                            }
                                                            }/>
                                </TabContentComponent>
                            </TabsWrapperComponent>
                        </div>
                    </>
                }

                <DialogComponent
                    open={isTestOrderSamplesPrintDialogOpen}
                    direction={"down"}
                    isShowCancel={false}
                    maxWidth={'md'}
                >

                    <div className="test-order-status-confirmation-dialog-container">
                        <div className="test-order-status-confirmation-dialog-image">
                            <img src={ImageConfig.OrderAddSuccess} alt={'imagePath'}/>
                        </div>
                        <div
                            className="test-order-status-confirmation-dialog-title">
                            {testOrderDetails?.patientDetails?.firstName} {testOrderDetails?.patientDetails?.lastName}
                        </div>
                        <div
                            className="test-order-status-confirmation-dialog-sub-text">
                            <div>{testOrderDetails?.facilityDetails?.name}</div>
                            &nbsp; &nbsp; | &nbsp; &nbsp;
                            <div>{testOrderDetails?.locationDetails?.name}</div>
                        </div>
                        <div className="test-order-status-confirmation-dialog-sub-body">
                            <SelectDropdownComponent
                                name={"size"}
                                label={'Print Size'}
                                placeholder={'Select Print Size'}
                                required={true}
                                options={LabelOptions}
                                valueKey={'code'}
                                getOptionLabel={(option => (option.title) || '')}
                                onUpdate={(value: string) => {
                                    setLabelSize(value)
                                }}
                            />
                            {
                                testOrderDetails?.samples?.map((sample: any, index: number) => {
                                    return <div className="panels-container">
                                        <div className="d-flex">
                                            <TooltipComponent
                                                placement={'top'}
                                                tooltip={sample?.testDetails?.name}
                                                arrow={true}>
                                                <div className="panel-name">{sample.testDetails?.name} </div>
                                            </TooltipComponent>
                                            :

                                        </div>
                                        <TooltipComponent
                                            placement={'top'}
                                            tooltip={sample?.patientBarcode}
                                            arrow={true}>
                                            <div className="barcode">
                                                {sample?.patientBarcode}
                                            </div>
                                        </TooltipComponent>
                                        <CopyComponent content={sample?.patientBarcode}/>
                                        {/*multiple sample have same reference, so store the current barcode to useState*/}
                                        <div ref={printSectionRef} style={{display: 'none'}}>
                                            <div id="print-section">
                                                <Barcode margin={0} ean128={true}
                                                         height={LabelConfigurations?.[labelSize]?.barcodeHeight}
                                                         fontSize={0}
                                                         value={currentBarCode}/>
                                                <div className={"print-label-value-wrapper"}>
                                                    <span className="print-label">Barcode:</span>
                                                    <span
                                                        className="print-value">{currentBarCode}</span>
                                                </div>
                                                <div className={"print-label-value-wrapper"}>
                                                    <span className="print-label">F.Name:</span>
                                                    <span
                                                        className="print-value">{sample?.orderDetails?.patientDetails?.firstName}</span>
                                                </div>
                                                <div className={"print-label-value-wrapper"}>
                                                    <span className="print-label">L.Name:</span>
                                                    <span
                                                        className="print-value">{sample?.orderDetails?.patientDetails?.lastName}</span>
                                                </div>
                                                <div className={"print-label-value-wrapper"}>
                                                    <span className="print-label">DOB:</span>
                                                    <span
                                                        className="print-value">{sample?.orderDetails?.patientDetails?.dateOfBirth ? commonService.formatDate(sample?.orderDetails?.patientDetails?.dateOfBirth) : "N/A"}</span>
                                                </div>
                                                <div className={"print-label-value-wrapper"}>
                                                    <span className="print-label">DOS:</span>
                                                    <span
                                                        className="print-value">{sample?.dateOfCollection ? commonService.formatDate(sample?.dateOfCollection) : "N/A"}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <ButtonComponent
                                            variant={'icon'}
                                            color={'primary'}
                                            className={'mrg-left-15 mrg-right-15'}
                                            handleClick={() => {
                                                setCurrentBarCode(sample?.barcode)
                                                setTimeout(() => handlePrint(), 0)
                                            }}
                                            // startIcon={<LocalPrintshopOutlinedIcon/>}
                                            disabled={!labelSize}
                                        >
                                            <LocalPrintshopOutlinedIcon/>
                                        </ButtonComponent>
                                        {
                                            !['draft'].includes(testOrderDetails?.status) &&
                                            <div className={"mrg-left-15"}>
                                                <PDFFileForRequisition testOrderDetails={testOrderDetails}
                                                                       sampleIndex={index}/>
                                            </div>
                                        }
                                    </div>
                                })
                            }
                        </div>
                        <div className="test-order-status-confirmation-dialog-sub-actions">
                            <ButtonComponent
                                color={"secondary"}
                                fullWidth={true}
                                handleClick={() => {
                                    setIsTestOrderSamplesPrintDialogOpen(false)
                                }
                                }
                                variant={"outlined"}>
                                Close
                            </ButtonComponent>
                        </div>
                    </div>
                </DialogComponent>
            </div>
        );

    }

;

export default TestOrderDetailsScreen;
